import React from 'react';
import { AvatarSizeTokens, AvatarTypeTokens, BorderRadiusTokens, ButtonTypeTokens, ColorTokens, DividerSizeTokens, FontTransformToken, GradientColorTokens, DiscussionStateTokens, SizeTypeTokens, StackAlignItems, StackJustifyContent, StackType, TagTypeTokens, TypographyTypeTokens, } from '@voltmoney/schema';
import { View, TouchableOpacity, } from 'react-native';
import Card from '../card/Card';
import Stack from '../stack/Stack';
import Typography from '../typography/Typography';
import _map from 'lodash-es/map';
import Button from '../button/Button';
import Space from '../space/Space';
import Avatar from '../avatar/Avatar';
import Tag from '../tag/Tag';
import Divider from '../divider/Divider';
const DicussionCard = ({ userLabel, state = DiscussionStateTokens.UNSEEN, userAvatarURL, title, subtitle, clubTitle, participantsLabel, participants, tags, onPress, ctaText, action, gradientColor = GradientColorTokens.D_5, margin, profileAction, triggerAction, }) => {
    if (!title)
        return React.createElement(React.Fragment, null);
    const handleAction = () => {
        onPress && onPress();
        action &&
            triggerAction &&
            triggerAction(action);
    };
    if (!title || !userLabel || !userAvatarURL)
        return React.createElement(React.Fragment, null);
    else
        return (React.createElement(Card, { onPress: handleAction, gradient: {
                colors: gradientColor,
            }, borderRadius: BorderRadiusTokens.BR2, padding: {
                vertical: SizeTypeTokens.XL,
                horizontal: SizeTypeTokens.MD,
            }, margin: margin, header: {
                children: (React.createElement(View, null,
                    React.createElement(Stack, { type: StackType.row, alignItems: StackAlignItems.center, justifyContent: StackJustifyContent.spaceBetween },
                        React.createElement(TouchableOpacity, { style: {
                                flex: 1,
                            }, onPress: () => triggerAction(profileAction) },
                            React.createElement(Stack, { type: StackType.row, alignItems: StackAlignItems.center },
                                React.createElement(Avatar, { uri: userAvatarURL, size: AvatarSizeTokens.XS }),
                                React.createElement(Space, { size: SizeTypeTokens.MD }),
                                React.createElement(Typography, { label: userLabel, type: TypographyTypeTokens.S6, numberOfLines: 1 }))),
                        _map(tags?.slice(0, 3), (item, index) => [
                            React.createElement(Tag, { key: index, ...item, margin: {
                                    right: index !== tags?.length - 1
                                        ? SizeTypeTokens.SM
                                        : SizeTypeTokens.NONE,
                                } }),
                        ])),
                    React.createElement(Space, { size: SizeTypeTokens.MD }),
                    React.createElement(View, { style: state === DiscussionStateTokens.SEEN
                            ? { opacity: 0.7 }
                            : { opacity: 1 } },
                        React.createElement(Typography, { label: title, type: TypographyTypeTokens.H4, textTransform: FontTransformToken.capitalize, numberOfLines: 2 })),
                    subtitle ? ([
                        React.createElement(Space, { size: SizeTypeTokens.MD }),
                        React.createElement(View, { style: state === DiscussionStateTokens.SEEN
                                ? { opacity: 0.7 }
                                : { opacity: 1 } },
                            React.createElement(Typography, { label: subtitle, numberOfLines: 2, type: TypographyTypeTokens.B6, color: ColorTokens.Grey_200 })),
                    ]) : (React.createElement(React.Fragment, null)),
                    clubTitle ? ([
                        React.createElement(Space, { size: SizeTypeTokens.MD }),
                        React.createElement(Tag, { margin: {
                                bottom: SizeTypeTokens.NONE,
                            }, label: clubTitle, type: TagTypeTokens.SECONDARY }),
                    ]) : (React.createElement(React.Fragment, null)))),
            }, body: {
                children: (React.createElement(Divider, { size: DividerSizeTokens.SM, margin: { vertical: SizeTypeTokens.LG }, color: ColorTokens.White_20 })),
            }, footer: {
                children: ctaText ? (React.createElement(Stack, { type: StackType.row, alignItems: StackAlignItems.center, justifyContent: StackJustifyContent.spaceBetween },
                    participants?.length > 0 ? (React.createElement(Stack, { type: StackType.row, alignItems: StackAlignItems.center },
                        React.createElement(Avatar, { size: AvatarSizeTokens.XS, type: AvatarTypeTokens.MULTIPLE, uris: participants }),
                        React.createElement(Space, { size: SizeTypeTokens.SM }),
                        React.createElement(Typography, { label: participantsLabel, type: TypographyTypeTokens.S6 }))) : (React.createElement(React.Fragment, null)),
                    React.createElement(View, { style: {
                            flex: 1,
                            flexDirection: 'row',
                            justifyContent: 'flex-end',
                        } },
                        React.createElement(Button, { onPress: handleAction, type: ButtonTypeTokens.SmallGhost, labelColor: ColorTokens.Grey_50, label: ctaText })))) : (React.createElement(React.Fragment, null)),
            } }));
};
export default React.memo(DicussionCard);
export { DicussionCard };
